import {
 API_HOST_EXPERTS_APPLY,
 API_HOST_REFDATA,
 API_HOST_USERS,
} from '../config';
import { CountriesService } from './CountriesService';
import { ExpertsApplyService } from './ExpertApplyService';
import { QualificationTypesService } from './QualificationTypesService';
import { QualificationLevelsService } from './QualificationLevelsService';
import { SubjectsService } from './SubjectsService';
import { ExpertiseService } from './ExpertiseService';
import {
 LocalLookupService,
 cachingService,
} from '@ofqual/portal-core/core/dataAccess';
import adminStatusLookups from './json/AdminStatuses.json';
import evaluatorStatusLookups from './json/EvaluatorStatuses.json';
import caseTypeSlaLookups from '../services/json/caseTypeSlaLookup.json';
import qualificationTypeLookupsLocal from './json/QualificationTypes.json';
import assessmentActivityLookupsLocal from './json/AssessmentActivities.json';
import assessmentExpertiseLookupsLocal from './json/AssessmentExpertise.json';
import teachingExpertiseLookupsLocal from './json/TeachingExpertise.json';

import { UserService } from './UserService';

export const expertsApplyService = new ExpertsApplyService( API_HOST_EXPERTS_APPLY);
export const expertiseService = new ExpertiseService(API_HOST_EXPERTS_APPLY);
export const countriesService = new CountriesService(API_HOST_REFDATA);
export const qualificationTypesService = new QualificationTypesService(API_HOST_REFDATA);
export const qualificationLevelsService = new QualificationLevelsService(API_HOST_REFDATA);
export const subjectsService = new SubjectsService(API_HOST_REFDATA);
export const cachedSubjectsService = cachingService(subjectsService);
export const AdminStatusService = new LocalLookupService(adminStatusLookups);
export const EvaluatorStatusService = new LocalLookupService(evaluatorStatusLookups);
export const QualificationTypeLookupsLocal = new LocalLookupService(qualificationTypeLookupsLocal);
export const AssessmentActivityLookupsLocal = new LocalLookupService(assessmentActivityLookupsLocal);
export const AssessmentExpertiseLookupsLocal = new LocalLookupService(assessmentExpertiseLookupsLocal);
export const TeachingExpertiseLookupsLocal = new LocalLookupService(teachingExpertiseLookupsLocal);

export const usersService = new UserService(API_HOST_USERS);
export const caseTypeSlaService = new LocalLookupService(caseTypeSlaLookups);
